import React, { useEffect, useState, useContext } from "react";
import Dropdown from "../../component/dropdown";
import DropdownOption from "./dropdown-option";
import FilterButton from "../../component/dropdown-filter";
import PaginationClassic from "../../component/pagination-classic";
import Table, { TableRow } from "../../component/table";
import { Bin, Edit } from "../../component/icons";
import Modal from "../../component/layout/modal";
import SearchForm from "../../component/search-form";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "../../service/context";
import { requestget, requestdelete } from "../../service/request";
import DataTable from "react-data-table-component";
import moment from "moment/moment";

const AssignmentDashboard = (props) => {
  const [toBeDeleted, setToBeDeleted] = useState(null);
  const [assignmentData, setAssignmentData] = useState([]);
  const [configurationData, setConfigurationData] = useState([]);
  const [openModal, setOpenModal] = useState(null);
  const [update, setUpdate] = useState(0);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);

  // /* -------------------------------------- Hardcoded activity assignment id -------------------------------------------- */
  // const assignmentID = "36eac023-c663-495a-b921-148cb3c1a622";
  // /*----------------------------------------------------------------------------------------------------------------------*/

  /* ---------------------- Default Access Token and Company ID ---------------------- */
  const ctx = useContext(UserContext);
  const companyId = ctx.user.company.id;
  const token = ctx.user.token;
  /* ------------------------------------------------------------------------------------ */

  const handleDelete = async () => {
    try {
      const response = await requestdelete(
        `/activityAssignment/${toBeDeleted}`,
        token
      );
      setToBeDeleted(null);
      setOpenModal(null);
      setUpdate(update + 1);
    } catch (error) {
      
    }
  };

  // Integrate get activity assignment by company id
  const getAssigmentByCompanyID = async () => {
    setLoader(true);
    try {
      const response = await requestget(
        `/activityAssignment/company`,
        token
      );
      if (!response.data) {
        throw "Something went wrong.";
      }
      setAssignmentData(response.data);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (update > 0) {
      getAssigmentByCompanyID();
    } else {
      // getConfigurationByCompanyID();
      getAssigmentByCompanyID();
    }
  }, [update]);

  /* -------------------------- Implementing Data table with sorting, pagination and searching ---------------- */

  // let width = window.screen.width;
  const [width, setWidth] = useState();

  const windowResize = () => {
    // console.warn("resize event is called");
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", windowResize);
  }, [window.innerWidth]);

  //  Internally, customStyles will deep merges your customStyles with the default styling.
  const customStyles = {
    headCells: {
      style: {
        fontFont: "24px",
        fontWeight: "bold",
        // backgroundColor:
      },
    },
  };

  const caseInsensitiveSort = (rowA, rowB) => {
    const a = Date.parse(rowA.created_date.toLowerCase());
    const b = Date.parse(rowB.created_date.toLowerCase());

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };

  const columns = [
    {
      name: "JOBID",
      selector: (row) => row.jobid,
      sortable: true,
    },
    {
      name: "CONFIGURATION NAME",
      selector: (row) => row.config_name,
      sortable: true,
      hide: "sm",
    },
    {
      name: "CREATED DATE",
      selector: (row) => row.created_date,
      sortable: true,
      hide: "md",
      sortFunction: caseInsensitiveSort,
      center: true,
    },
    {
      name: "ACTION",
      selector: (row) => row.action,
      right: true,
    },
  ];

  // Creating state form table data.
  const [tableData, setTableData] = useState();

  useEffect(() => {
    if (assignmentData.length > 0) {
      let arr = [];
      assignmentData.map((item) => {
        const obj = {
          id: item.activity_assignment_id,
          jobid: item.job_id,
          config_name: item?.configuration?.configuration_name,
          created_date: moment(item.createdAt).format("DD MMM, YYYY HH:mm"),
          action: (
            <>
              <Edit
                tag="button"
                type="button"
                title="Edit"
                onClick={() =>
                  navigate(`/assignment/assign/${item.activity_assignment_id}`)
                }
              />
              <Bin
                tag="button"
                type="button"
                title="Delete"
                onClick={() => {
                  setToBeDeleted(item.activity_assignment_id);
                  setOpenModal(1);
                }}
              />
            </>
          ),
        };
        arr.push(obj);
      });
      setTableData(arr);
    }
  }, [assignmentData]);

  const paginationComponentOptions = {
    noRowsPerPage: true,
  };

  // Search functionality
  const [searchText, setSearchText] = useState();
  const [filterData, setFilterData] = useState();

  useEffect(() => {
    console.warn("searchText ---", searchText);
    if (searchText && tableData) {
      const filterResult = tableData.filter(
        (item) =>
          (item.jobid &&
            item.jobid.toLowerCase().includes(searchText.toLowerCase())) ||
          (item.config_name &&
            item.config_name
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (item.created_date &&
            item.created_date.toLowerCase().includes(searchText.toLowerCase()))
      );
      // console.warn("filterResult ---", filterResult);
      setFilterData(filterResult);
    } else {
      setFilterData();
    }
  }, [searchText]);

  // hide and show columns on desktop size
  const ExpandedComponent = ({ data }) => {
    return (
      <>
        {/* <p className="p-2 text-xs">
          <span className="py-2 font-medium"> CONFIGURATION NAME :</span>
          {data.config_name}
        </p>
        <p className="p-2 text-xs">
          <span className="py-2 font-medium"> CREATED DATE :</span> {data.created_date}
        </p> */}
        <p className={`${width < 959 ? "block" : "hidden"} p-1 text-xs`}>
          <span className="py-2"> CREATED DATE :</span> {data.created_date}
        </p>
        <p className={`${width < 599 ? "block" : "hidden"} p-1 text-xs`}>
          <span className="py-2"> CONFIGURATION NAME :</span> {data.config_name}
        </p>
      </>
    );
  };

  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      <header className="flex justify-between items-center sm:flex sm:justify-between sm:items-center mb-5">
        {/* <div className="sm:mb-0">
          <h1 className="text-2xl md:text-3xl text-slate-800 font-bold">
            Assign Tasks
          </h1>
          <h4 className="text-sm text-slate-500 leading-4">
            Assign tasks to your users.
          </h4>
        </div> */}
        {/* <div className="flex flex-col sm:flex-row justify-start sm:justify-end">
          <div className="flex">
            <button className="btn flex-auto ml-0 sm:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white">
              <svg
                className="w-4 h-4 fill-current opacity-50 shrink-0 mr-2"
                viewBox="0 0 16 16"
              >
                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
              </svg>
              Create New
            </button>
          </div>
        </div> */}
      </header>

      <div className="flex-auto sm:flex sm:flex-row items-center space-x-0 sm:space-x-2 mb-2 ">
        <div className="flex flex-row items-center space-x-1 mb-2">
          <SearchForm
            placeholder="Search"
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>

      {/* Implementing Data table */}
      <div className="overflow-x-auto shadow-md rounded border ">
        <DataTable
          columns={columns}
          data={filterData ? filterData : tableData}
          highlightOnHover
          progressPending={loader}
          responsive
          striped
          fixedHeader
          pagination
          paginationComponentOptions={paginationComponentOptions}
          customStyles={customStyles}
          expandableRows={width < 597}
          expandableRowsComponent={ExpandedComponent}
          expandOnRowClicked={false}
          expandOnRowDoubleClicked={false}
          expandableRowsHideExpander={false}
          sortIcon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
              className="fill-current"
              style={{ display: "block !important", color: '#94a3b8' }}
            >
              <path d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z" />
            </svg>
          }
        />
      </div>

      <Modal
        id="danger-modal"
        modalOpen={openModal}
        title="Delete Assignment"
        description="Are you sure you want to delete your assignment? All of your data will be permanently removed from our servers forever. This action cannot be undone."
        onCancel={() => {
          setToBeDeleted(null);
          setOpenModal(null);
        }}
        onApprove={() => handleDelete()}
        cancelBtnText="Cancel"
        okBtnText="Delete"
      />
    </div>
  );
};

AssignmentDashboard.auth = { path: "/assignment", role: "super-admin" };
export default AssignmentDashboard;
